<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      Doctor Payment
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="3">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Select [Start Date - End Date]"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              range
              :max="nowDate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <template>
          <v-autocomplete
              :items="doctors"
              item-text="dr_name"
              item-key="id"
              item-value="id"
              label="Doctor List"
              v-model="search_doctor_id"
              :loading="loading"
              outlined
              dense
              chips
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            outlined
            dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn
                depressed
                color="primary"
                append-icon="mdi-printer"
                v-on:click="printList"
            >Print
            </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1"
          :search="search"
          dense
          :loading="loadingstatus"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          mobile-breakpoint="0"
          :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:item.created_at="{ item }">
          {{ formatPaymentDateTime(item) }}
        </template>
        <template v-slot:item.payment_amount="{ item }">
          <span v-if="paymentSeeCheck == true"> {{ item.payment_amount }}</span>
        </template>
        <template v-slot:item.received_by_user_id="{ item }">
          {{ getReceivedByName(item) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="doctor_ledger(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="orange"
                  label
                  outlined
                  small
              ><v-icon left> mdi-motorbike </v-icon>
                >>
              </v-chip>
            </template>
            <span>Doctor Payment Statement</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="printReceipt(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  color="green"
                  label
                  outlined
                  small
              ><v-icon left> mdi-printer </v-icon>
              </v-chip>
            </template>
            <span>Print Receipt</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment/moment";

export default {
  data() {
    return {
      search: "",
      sortBy: "operation.name",
      sortDesc: false,
      date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      nowDate: moment().format('YYYY-MM-DD'),
      search_doctor_id: '',
      menu2: false,
      loading: true,
      loadingstatus: true,
      paymentSeeCheck: false,
      headers: [
        { text: "Date & Time", value: "created_at" },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Paid Amount", value: "payment_amount" },
        { text: "Note", value: "payment_note" },
        { text: "Paid By", value: "user.full_name" },
        { text: "Received By", value: "received_by_user_id" },
        { text: "Action", value: "actions", sortable: false },
      ],
      login_user_id: localStorage.getItem("userId"),

      desserts: [],
      doctors: [],
      items: [
        {text: "Dashboard", disabled: false, href: "/",},
        {text: "Doctors", disabled: true},
        {text: "Payment List", disabled: true,},
      ],
      returnUrl: atshq.defaults.headers.common.base_URL,
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getDoctors();
    this.initialize(this.date);
  },
  watch:{
    date() {
      this.desserts = [];
      if (this.date.length == 2) {
        if (!this.validateSelectedDate()) {
          return;
        }
        this.initialize();
      }
    },
    search_doctor_id() {
      this.initialize()
    }
  },
  methods: {
    validateSelectedDate() {
      const dates = Array.isArray(this.date) ? this.date : [this.date];
      const hasFutureDate = dates.some((selectedDate) => selectedDate && selectedDate > this.nowDate);

      if (hasFutureDate) {
        this.$noty.error("Future date cannot be selected");
        this.date = [this.nowDate, this.nowDate];
        return false;
      }

      return true;
    },
    getReceivedByName(item) {
      if (item.received_by_user_id && item.received_by && item.received_by.full_name) {
        return item.received_by.full_name;
      }
      if (item.doctor && item.doctor.dr_name) {
        return item.doctor.dr_name;
      }
      return '-';
    },
    formatPaymentDateTime(item) {
      if (item.created_at) {
        return moment(item.created_at).format('DD MMM, YYYY hh:mm A');
      }
      if (item.payment_date) {
        return moment(item.payment_date).format('DD MMM, YYYY');
      }
      return '-';
    },
    normalizedDateRange() {
      const dates = Array.isArray(this.date)
          ? this.date.filter(function (selectedDate) {
            return !!selectedDate;
          })
          : [];

      if (dates.length < 2) {
        return null;
      }

      return dates.slice(0, 2).sort();
    },
    getDoctors() {
      atshq
          .get("doctors?status=1")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    initialize() {
      if (!this.validateSelectedDate()) {
        return;
      }
      this.loading = true;
      this.desserts = []
      atshq
          .get("doctor/doctor-payment?date="+ this.date + "&doctor_id=" + this.search_doctor_id + "&login_user_id=" + this.login_user_id)
          .then((response) => {
            this.desserts = response.data.data;
            this.loadingstatus = false;
            this.loading = false;
            this.paymentSeeCheck = response.data.paymentSeeCheck
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          });
    },
    doctor_ledger(item) {
      window.open(
          this.returnUrl + "doctor-payment-statement?doctor_id=" + item.doctor.id
      );
    },
    printList() {
      const dateRange = this.normalizedDateRange();
      if (!dateRange) {
        this.$noty.error('Please select start and end date');
        return;
      }
      if (!this.validateSelectedDate()) {
        return;
      }
      window.open(
          this.returnApiBaseURL
          + "print/doctor-payment-list?date="
          + dateRange.join(',')
          + "&doctor_id="
          + (this.search_doctor_id || '')
          + "&login_user_id="
          + this.login_user_id
      );
    },
    printReceipt(item) {
      window.open(this.returnApiBaseURL + "print/doctor-payment-receipt/" + item.id);
    },
  },
};
</script>